import React from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

/**
 * Bluebox displayMessageBox WARNING before Verzenden naar Afas Profit.
 */
const AfasVerzendenValidationModal = ({ isOpen, message, onClose }) => (
    <Modal
        isOpen={isOpen}
        toggle={onClose}
        centered
        zIndex={2000}
    >
        <ModalHeader toggle={onClose}>
            Verzenden naar Afas Profit
        </ModalHeader>
        <ModalBody>
            <pre
                className="mb-0 text-dark"
                style={{
                    whiteSpace: 'pre-wrap',
                    fontFamily: 'inherit',
                    fontSize: '0.95rem',
                }}
            >
                {message}
            </pre>
        </ModalBody>
        <ModalFooter>
            <Button color="primary" onClick={onClose} className="btn-color-style">
                OK
            </Button>
        </ModalFooter>
    </Modal>
);

export default AfasVerzendenValidationModal;
